import React from 'react';
import { Grid, Paper } from '@mui/material';
import DashboardLayout from '../../../shared/layout/DashboardLayout';
import AdminUsersTable from '../components/AdminUsersTable';
import CreateUserForm from '../components/CreateUserForm';

export default function UsersManagementPage() {
  return (
    <DashboardLayout>
      <Grid item xs={12} sx={{ mb: 2 }}>
        <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
          <CreateUserForm />
        </Paper>
      </Grid>
      <Grid item xs={12}>
        <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
          <AdminUsersTable />
        </Paper>
      </Grid>
    </DashboardLayout>
  );
}
